// extracted by mini-css-extract-plugin
export var messageSideLeft = "_j4-1";
export var messageSideRight = "_j4-2";
export var subscribeToBackInStockBubbleContainer = "_j4-0";